import client from './client';
import { unwrapData } from './response';

// List professionals
export const listProfessionals = async (filters = {}) => {
  const response = await client.get('/professionals', { params: filters });
  return unwrapData(response);
};

// Get professional by ID
export const getProfessionalById = async (id) => {
  const response = await client.get(`/professionals/${id}`);
  return unwrapData(response, null);
};

// Create professional
export const createProfessional = async (data) => {
  const response = await client.post('/professionals', data);
  return unwrapData(response, null);
};

// Update professional
export const updateProfessional = async (id, data) => {
  const response = await client.patch(`/professionals/${id}`, data);
  return unwrapData(response, null);
};

// Update professional status
export const updateProfessionalStatus = async (id, active) => {
  const response = await client.patch(`/professionals/${id}/status`, { active });
  return unwrapData(response, null);
};

// Upload professional photo
export const uploadProfessionalPhoto = async (id, file) => {
  const formData = new FormData();
  formData.append('photo', file);

  const response = await client.post(`/professionals/${id}/photo`, formData);
  return unwrapData(response, null);
};

// Delete professional
export const deleteProfessional = async (id) => {
  const response = await client.delete(`/professionals/${id}`);
  return unwrapData(response, null);
};

export const PROFESSIONALS_TODO = [
  'Para subir fotos, configurar AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_S3_BUCKET y AWS_S3_REGION en el entorno de la API.',
  'Opcional: AWS_S3_PUBLIC_BASE_URL si el bucket se sirve por CloudFront/CDN.'
];
